import React, {Component} from 'react';
import PropTypes from 'prop-types';

/**
 * Responsive list showing sliced (if required) list using callback as function.
 * By default child callback function is used as Array.map callback.
 * If callback needs to be passed just with list, set 'map' prop to false.
 */
class ResponsiveList extends Component {
    constructor(props) {
        super(props);

        this.onWindowResize = this.onWindowResize.bind(this);
    }

    onWindowResize() {
        this.forceUpdate();
    }

    componentDidMount() {
        window.addEventListener('resize', this.onWindowResize);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.onWindowResize);
    }

    render() {
        let {className = '', list, children, map = true} = this.props;

        let sliced = list;

        if (window.matchMedia('(max-width: 479px)').matches) {
            sliced = list.slice(0, 2); //column
        } else if (window.matchMedia('(max-width: 759px)').matches) {
            sliced = list.slice(0, 2);10
        } else if (window.matchMedia('(max-width: 1023px)').matches) {
            sliced = list.slice(0, 3);
        } else if (window.matchMedia('(max-width: 1374px)').matches) {
            sliced = list.slice(0, 4);
        } /*else if (window.matchMedia('(min-width: 1200px)').matches) {
            sliced = list.slice(0, 5);
        }*/

        if (map && sliced.map)
            return <div className={className}>{sliced.map(children)}</div>;
        else {
            return children(sliced);
        }
    }
}

ResponsiveList.propTypes = {
    children: PropTypes.func
};

export default ResponsiveList;


// WEBPACK FOOTER //
// ./src/components/index/ResponsiveList.js